import React, { useState } from "react";
import closeIcon from "../../img/closeIcon.svg";
import "../../components/Filters/Filters.css";
import CustomSelect from "../../utils/CustomSelect/CustomSelect";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";

const Filters = (props) => {

    const {
        closeModal,
        onHandlerFilters,
        optionFilterCargoCaseConsignee,
        optionFilterCargoCaseVessel,
        optionFilterCargoCaseShipper,
        optionFilterCargoCaseCarrier,
        optionFilterCargoCaseDate
    } = props;

    const { getRequestDataToggle } = useAuth();

    const onHandlerFilter = (value, typeFilter) => {
        onHandlerFilters(typeFilter, value.label)
    }

    const optionsItemsConsignee = optionFilterCargoCaseConsignee.map((el, i) => ({
        "value": i,
        "label": el
    }))

    const optionsItemsVessel = optionFilterCargoCaseVessel.map(el => ({
        "value": el?.id,
        "label": el?.name
    }))

    const optionsItemsShipper = optionFilterCargoCaseShipper.map(el => ({
        "value": el?.id,
        "label": el?.name
    }))

    const optionsItemsCarrier = optionFilterCargoCaseCarrier.map(el => ({
        "value": el?.id,
        "label": el?.name
    }))

    const optionsItemsDate = optionFilterCargoCaseDate.map((el, i ) => ({
        "value": i,
        "label": el
    }))

    const filterItems = [
        {
            id: 0,
            type: 'consignee',
            optionsItems: optionsItemsConsignee,
            labelName: 'Consignee'
        },
        {
            id: 1,
            type: 'vessel',
            optionsItems: optionsItemsVessel,
            labelName: 'Vessel'
        },
        {
            id: 2,
            type: 'carrier',
            optionsItems: optionsItemsCarrier,
            labelName: 'Carrier'
        },
        {
            id: 3,
            type: 'shipper',
            optionsItems: optionsItemsShipper,
            labelName: 'Shipper'
        },
        {
            id: 4,
            type: 'date',
            optionsItems: optionsItemsDate,
            labelName: 'Date'
        }
    ]

    const onHandlerResetFilters = () => {
        getRequestDataToggle();
    }

    return (
            <div className="filters-modal">
                <div className="filters-modal__title">
                    <h3 className="filters-modal__title-name">
                        Filters
                    </h3>
                    <img onClick={closeModal} className="filters-modal__title-icon" src={closeIcon} alt={'иконка крестик'}/>
                </div>
                <div className="filters-modal-inputs-block">
                    {filterItems.map(el => {
                        return (
                            <div key={el?.id} className="filters-modal-inputs-block__input-item">
                            <label className="filters-modal-inputs-block__label">{el?.labelName}</label>
                                <CustomSelect
                                    options={el?.optionsItems}
                                    onChange={(valueFilter) => onHandlerFilter(valueFilter, el?.type)}
                                />
                            </div>
                        )})}
                     <div className="filters-modal__button-block">
                        <button onClick={onHandlerResetFilters} className="filters-modal__button-clear" type={"button"}>Reset filters</button>
                    </div>
                </div>
            </div>
    )
}
export default Filters;